import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BaseViewComponent } from 'projects/shared/core/interfaces/baseViewComponent';
import { LookupService } from 'projects/shared/core/services/lookup.service';
import { StateNameModel } from 'projects/rms/app/api/models/state-name-model';

@Component({
  selector: 'rms-search-airport',
  templateUrl: './search-airport.component.html',
  styleUrls: ['./search-airport.component.css']
})
export class SearchAirportComponent extends BaseViewComponent {
  @Input() set stateList(value: StateNameModel[]) {
    if (value) {
      this.states = value;
    }
  };
  states: StateNameModel[];

  @Output() search = new EventEmitter<any>(); 

  formSearchGroup: FormGroup;
  isSearching: boolean = false;

  constructor(
    private _formBuilder: FormBuilder,
    lookupService: LookupService) {
    super(lookupService);

    this.formSearchGroup = this._formBuilder.group({
      airportName: [""],
      iataCode: [""],
      city: [""],
      state: [""]
    });
  }

  onKeyDown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
      this.onSearchClick();
    }
  }

  onSearchClick() {
    this.isSearching = true;
    let searchKeyValues = {
      "AirportName": this.formSearchGroup.get("airportName").value,
      "IATACode": this.formSearchGroup.get("iataCode").value,
      "City": this.formSearchGroup.get("city").value,
      "State": this.formSearchGroup.get("state").value ? this.states.filter(state => state.id === this.formSearchGroup.get("state").value.id)[0].abbreviation : ""
    };
    this.search.emit(searchKeyValues);
  }

  onSearchComplete() {
    this.isSearching = false;
  }
}